module.exports = __webpack_public_path__ + "media/react-dashboard@xs-f8cd3f2865701556ba7f01767b4088ad.jpg";